import React, { useState, useEffect } from "react";
import SearchBar from "./SearchBar";
import VideoList from "./VideoList";
import VideoPlayer from "./VideoPlayer";
import useVideos from "../hooks/useVideos";

const App = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);

  const [videos, search] = useVideos("buildings");
  useEffect(() => {
    if (videos.length == 0) {
      return;
    }

    setSelectedVideo(videos[0]);
  }, [videos]);

  return (
    <div className="ui container" style={{ marginTop: "10px" }}>
      <span>App Home</span>
      <SearchBar onSubmit={search} />
      <div>
        <div className="ui grid">
          <div className="ui row">
            <div className="eleven wide column">
              <VideoPlayer video={selectedVideo} />
            </div>
            <div className="five wide column">
              <VideoList videos={videos} onVideoSelected={setSelectedVideo} />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default App;
